export default {"src":"/_next/static/media/deco_paypal_dark.ffdff6f6.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};